import { Pill, Group } from "@mantine/core";

interface Props {
  name: string;
  value?: string[];
}

const ArrayStringFilter = ({ name, value }: Props) => {
  if (!value?.length) return null;

  if (value.length === 1) {
    return (
      <Group gap="0">
        <Pill>{name}</Pill>
        <Pill>=</Pill>
        <Pill>{value[0]}</Pill>
      </Group>
    );
  }

  return (
    <Group gap="0">
      <Pill>{name}</Pill>
      <Pill>IN</Pill>
      <Pill>({value.join(", ")})</Pill>
    </Group>
  );
};

export default ArrayStringFilter;
